export default __webpack_public_path__ + "static/biblioAntof-eefcc0793c0aa4098aaffcb88d1c5e07.jpg";